<template>
    <a-modal
      v-model="locus"
      title=""
      :footer="null"
      :width="850"
      :maskClosable="maskClosable"
      centered
      :maskStyle="{ backgroundColor:'rgba(0, 0, 0, 0.3)' }"
      :destroyOnClose="true"
      :bodyStyle="{ position:'relative',zIndex:'0',borderRadius:'20px',overflow:'hidden' }"
      wrapClassName="locusWrap"
    >
            <a-row :gutter="24">
                <a-col class="no-padding" :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
                    <div class="locus-map" id="locusMap" ref="locusMap"></div>   
                </a-col>
                <a-col class="no-padding locus-col-box" :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
                     <div class="locus-button-group">
                        <a-button-group>
                          <a-button type="primary" size="small">日</a-button>
                          <a-button size="small">周</a-button>
                          <a-button size="small">月</a-button>
                          <a-button size="small"><img src="../../assets/locus_date_icon.png" alt="" /></a-button>
                        </a-button-group>
                        <a-button-group>
                            <span class="locus-time">2018/12/28 — 2018/12/29</span>
                        </a-button-group>
                     </div>
                     <div class="locus-btn">
                          <a-button type="primary">查询轨迹</a-button>
                          <a-button type="primary">开启追踪</a-button>
                     </div>
                     <div class="locus-ul">
                         <ul>
                             <li><label>姓名：</label>刘三姐 - 机构 - 分组</li>
                             <li><label>设备：</label>Z50 - 123654789157894532</li>
                             <li>
                                <label>位置：</label>北京市通州区
                                <span class="locus-ul-time">2018/12/29 10:30</span>
                             </li>
                             <li>
                                 <label>定位方式：</label>
                                 <span class='posType posTypeOne'></span>
                                 <span class='posType posTypeTwo'></span>
                                 <span class='posType posTypeThree'></span>
                                 <span class='posType posTypeFour'></span>
                                 <span class='posType posTypefive'></span>
                             </li>
                             <li><label>状态：</label>未告警</li>
                             <li class="locus-info-box">
                                 <label>历史轨迹：</label>
                                 <div class="locus-info-content">
                                     <ul>
                                         <li>
                                              位置位置位置位置位置位置位置位置<br/>
                                              10:30<span class="reside-time">停留45分钟</span>
                                         </li>
                                         <li>
                                              位置位置位置位置位置位置位置位置<br/>
                                              10:30<span class="reside-time">停留45分钟</span>
                                         </li>
                                         <li>
                                              位置位置位置位置位置位置位置位置<br/>
                                              10:30<span class="reside-time">停留45分钟</span>
                                         </li>
                                         <li>
                                              位置位置位置位置位置位置位置位置<br/>
                                              10:30<span class="reside-time">停留45分钟</span>
                                         </li>
                                         <li>
                                              位置位置位置位置位置位置位置位置<br/>
                                              10:30<span class="reside-time">停留45分钟</span>
                                         </li>
                                         <li>
                                              位置位置位置位置位置位置位置位置<br/>
                                              10:30<span class="reside-time">停留45分钟</span>
                                         </li>
                                         <li>
                                              位置位置位置位置位置位置位置位置<br/>
                                              10:30<span class="reside-time">停留45分钟</span>
                                         </li>
                                         <li>
                                              位置位置位置位置位置位置位置位置<br/>
                                              10:30<span class="reside-time">停留45分钟</span>
                                         </li>
                                     </ul>
                                 </div>
                             </li>
                         </ul>
                     </div>
                     <i class="commonCircle sixCircle"></i>
                     <i class="commonCircle sevenCircle"></i>
                     <i class="commonCircle eightCircle"></i>
                </a-col>
            </a-row>
    </a-modal>

</template>

<script>
    import BMap from 'BMap'
    import iconImg from '../../assets/point_normal_icon.png'
    import iconPointImg from '../../assets/locus_icon.png'
    
    let map;
    let data = [
                  {"lon":116.43971,"lat":39.955284},
                  {"lon":116.29949,"lat":39.906967},
                  {"lon":116.29155,"lat":39.91161},
                  {"lon":116.29967,"lat":39.90697}
               ];
    let pointArray = new Array();

    export default {
        name: 'ZLocus',
        data() {
            return {
                maskClosable: false,
                locus: false,                
            }
        },
        mounted(){
            this.Map()
        },
        methods:{
            Map(){                
                this.createMap();
                this.setMapEvent();
                this.addMapMarkerPolyline();
            },
            createMap() {
                map = new BMap.Map(this.$refs.locusMap, { enableAutoResize: false, enableMapClick: false });
                    map.centerAndZoom(new BMap.Point(116.404,39.915),12);
            },
            setMapEvent() {
                map.enableScrollWheelZoom(true);
            },
            addMapMarkerPolyline() {
                let locusIcon = new BMap.Icon(iconImg, new BMap.Size(29, 30), {
                    anchor: new BMap.Size(10, 30),
                    infoWindowAnchor: new BMap.Size(10, 0)
                });
                let locusPointIcon = new BMap.Icon(iconPointImg, new BMap.Size(36, 36), {
                    anchor: new BMap.Size(14, 22),
                    infoWindowAnchor: new BMap.Size(14, 0)
                });                
                let j=0;         
                for(let i=0;i<data.length;i++){
                    let img = i == 0 ? locusIcon : i == data.length - 1 ? locusIcon : locusPointIcon;
                    let obj = data[i];
                    let point = new BMap.Point(obj.lon, obj.lat);
                    pointArray.push(point);
                    let info_html = "<div class='showWorningContent'><span>时间：</span>2018/12/29   10:30<br/><span>位置：</span><span>北京市通州区XXXXXXXXX</span><br/><span>停留时间：</span>45分钟</div>";
                    let locusOpts = {
                        width: 240
                    }
                    let infoWindow = new BMap.InfoWindow(info_html, locusOpts);
                    let marker = new BMap.Marker(point, { icon: img });
                    marker.id = i;
                    marker.setZIndex(i == 0 ? data.length : i == data.length - 1 ? data.length : i);
                    if (i > 0) {
                        let obj_s = data[i - 1];
                        let point_s = new BMap.Point(obj_s.lon, obj_s.lat);
                        let polyPointList = [point_s, point];
                        let polyline = new BMap.Polyline(polyPointList, { strokeStyle: "solid", strokeColor: "#3e86ef", strokeWeight: 6, strokeOpacity: 1 });
                        map.addOverlay(polyline);
                    }
                    if (i != 0 && i != data.length - 1) {
                        j++;
                        let label = new BMap.Label(j, { offset: new BMap.Size(0, 2) });
                        label.setStyle({
                            maxWidth: "none",
                            width: "36px",
                            height: "36px",
                            lineHeight: "36px",
                            padding: "0",
                            marginBottom: "0",
                            backgroundColor: "none",
                            color: "#3d86ef",
                            border: "0",
                            fontWeight: "bold",
                            fontSize: "12px",
                            textAlign: "center",
                            overflow: "hidden"
                        });
                        marker.setLabel(label);                            
                    }
                    marker.addEventListener("click", function () {
                        map.centerAndZoom(new BMap.Point(obj.lon, obj.lat), map.getZoom());
                        marker.openInfoWindow(infoWindow, point); //开启信息窗口                    
                        // locusWindow();
                    });
                    map.addOverlay(marker);                    
                    map.centerAndZoom(point, map.getZoom());
                    if (i == data.length - 1) {
                        map.setViewport(pointArray);
                        map.zoomOut();                        
                    }              
                 }
            }
            
            // LocusByCarid(){
            //     console.log(2)
            //     this.locus = true
            // }
        }
    }
    // window.LocusByCarid = function(){
    //     console.log(2)
    //     // this.locus = true
    // }
</script>